<div class="bundle-products" data-cy="bundle-products">
  <div class="media">
    <a [href]="link" class="image" data-cy="product-image-link">
      <img [src]="image?.image?.url" [alt]="image?.title" />
    </a>
  </div>
  <div class="content sir-text-style-paragraph-s-default">
    @if (manufacturer?.name) {
      <p class="vendor-name" data-cy="vendor-name">
        {{ manufacturer.name }}
      </p>
    }
    <a [href]="link" class="product-name sir-text-style-paragraph-m-bold" data-cy="product-name">
      {{ title }}
    </a>
    @if (sku) {
      <p class="sku" data-cy="product-sku">
        SKU: <span class="sku-number sir-text-style-paragraph-s-bold">{{ sku }}</span>
      </p>
    }
  </div>
</div>
